<template>
  <v-card flat class="border-right-only overflow-y-auto" max-height="500px">
    <v-card-text class="px-1 px-sm-4">
      <!-- REGISTRAR CATEGORIA -->
      <v-row justify="end">
        <producto-categoria-create
          :dialogCategoria="dialogCreate"
          @close-dialog="dialogCreate = false"
          :parent="parent"
          @refresh-categorias="fetchCategoria()"
        ></producto-categoria-create>
      </v-row>
      <div class="mt-2"></div>
      <!-- Lista de categorías -->
      <v-list dense>
        <!-- Botón para crear nueva categoría -->
        <v-list-item @click="dialogCreate = true">
          <v-list-item-avatar>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Nueva categoría</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- Categorías existentes -->
        <v-list-item-group v-if="categoriasLoaded && categoriasFiltradas.length">
          <v-list-item v-for="categoria in categoriasFiltradas" :key="categoria.id">
            <v-list-item-avatar>
              <v-checkbox
                :input-value="selectedCategoriasFinal"
                :value="categoria"
                @change="$emit('update:selectedCategoriasFinal', $event)"
                hide-details
                dense
              ></v-checkbox>
            </v-list-item-avatar>
            <v-list-item-avatar v-if="categoria.imagen" tile size="32" class="mr-2">
              <v-img :src="categoria.imagen" :alt="categoria.name"></v-img>
            </v-list-item-avatar>
            <v-list-item-content @click="seleccionarCategoria(categoria)">
              <v-list-item-title>{{ categoria.name }}</v-list-item-title>
              <v-list-item-subtitle v-if="categoria.uso && categoria.uso !== 'ambos'">
                <v-chip
                  x-small
                  :color="categoria.uso === 'venta' ? 'teal darken-1' : 'orange darken-2'"
                  dark
                  style="font-size: 10px; height: 16px"
                >
                  {{ categoria.uso }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="categoria.tiene_hijos" class="my-0">
              <v-btn icon @click.stop="seleccionarCategoria(categoria)" aria-label="Ver subcategorías">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
        <div
          v-else-if="categoriasLoaded && !categoriasFiltradas.length"
          class="text-center pa-6 text--secondary"
          style="opacity: 0.6"
        >
          <v-icon size="36" class="mb-2">mdi-folder-outline</v-icon>
          <div>No hay categorías registradas</div>
        </div>
        <!-- mientras carga -->
        <div v-else class="text-center pa-6 text--secondary">
          <v-skeleton-loader type="list-item" class="mx-auto" max-width="300" />
        </div>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductoCategoriaCreate from "@/components/producto/categorias/ProductoCategoriaCreate";
import ProductosAPI from "@/api/productos";

export default {
  name: "ProductoCategoriasTreeBranch.vue",
  components: {
    ProductoCategoriaCreate,
  },
  props: {
    parent: {
      type: Object,
    },
    selectedCategoriasFinal: {
      type: Array,
    },
    usoFiltro: {
      type: String,
      default: 'todos',
    },
  },
  data() {
    return {
      dialogCreate: false,
      categorias: this.parent.categorias || [],
      categoriasLoaded: true, // para saber si ya cargó
    };
  },
  computed: {
    categoriasFiltradas() {
      if (!this.usoFiltro || this.usoFiltro === 'todos') return this.categorias;
      return this.categorias.filter(
        (c) => !c.uso || c.uso === 'ambos' || c.uso === this.usoFiltro
      );
    },
  },
  methods: {
    seleccionarCategoria(categoria) {
      this.$emit("processCategoria", categoria);
    },

    fetchCategoria() {
      this.categoriasLoaded = false;
      console.log(this.parent);

      if (!this.parent?.nombre_padre) return;
      console.log(this.parent.nombre_padre);

      ProductosAPI.indexCategorias(this.parent.nombre_padre)
        .then((response) => {
          const children = response.data?.parent?.children || [];
          this.categorias = children;
        })
        .catch((e) => {
          console.error("Error al obtener categorías:", e);
        })
        .finally(() => {
          this.categoriasLoaded = true;
        });
    },
  },

 created() {
  // Solo llamar fetchCategoria si no hay hijos pasados desde el padre
  if (!this.categorias.length) {
    this.fetchCategoria();
  }
},
};
</script>

<style scoped>
.border-right-only {
  border-right: 1px solid #ddd; /* o el color que quieras */
}
</style>
